module.exports = "pegasus/assets/themelp1/small/14.png";